import { useEffect, useRef } from 'react';
import BaseSetting from '@config/BaseSetting';

export default function useSearchDelay(
  { actionFunc, resetFunc, onChangeKeyword },
  keyword,
  moreTriggers = [],
  allowNumberChar = BaseSetting.allowTypeRequestLength
) {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // skip on first char input
    }

    if (onChangeKeyword) onChangeKeyword();

    const delayID = setTimeout(() => {
      if (keyword.length > allowNumberChar) {
        actionFunc();
      }

      if (keyword.length === 0 && resetFunc) {
        resetFunc();
      }
    }, BaseSetting.searchTypeDelay);

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(delayID);
  }, [keyword, ...moreTriggers]);

  return [];
}
